import { EmblaOptionsType } from "embla-carousel-react";

import { breakpointsValuesV2, breakpointsValues } from "@ui/themes/default";
import { mq } from "@ui/helpers";

import { BreakpointsVersion } from "./Tabs.types";

export const getEmblaConfig = (
  breakpointsVersion: BreakpointsVersion = "v2",
): EmblaOptionsType => {
  const breakpoint =
    breakpointsVersion === "v1"
      ? breakpointsValues.tablet
      : breakpointsValuesV2.smallTablet;

  return {
    align: "start",
    dragFree: true,
    active: true,
    breakpoints: {
      [mq([breakpoint], undefined, false)]: {
        active: false,
      },
    },
  };
};
